import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlacementQuizPageComponent } from './placement-quiz-page/placement-quiz-page.component';
import { WindowService } from '../shared/window.service';
import { SafeUrlPipeModule } from '../pipes/safe-url.pipe';
import { TranslatePipeModule } from '../shared/translate.pipe';
import { TranslationService } from '../shared/translation.service';
import { UserwaySyncModule } from '../shared/userway-sync.directive';

@NgModule({
  imports: [
    CommonModule,
    TranslatePipeModule, 
    SafeUrlPipeModule,
    UserwaySyncModule
  ],
  declarations: [PlacementQuizPageComponent],
  providers:[WindowService, TranslationService]
})
export class PlacementQuizModule { }



// WEBPACK FOOTER //
// ./ts/app/placement-quiz/placement-quiz.module.ts